<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Goods Receipt</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="accent" small to="/new-goods-receipt">
            <v-icon left dark>mdi-plus</v-icon>Create Goods Receipt
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" xs="12" md="3" class="subtitle-2 text--primary">
            <span>Total Purchases: {{TotalPurchases && TotalPurchases.toLocaleString()}}</span><br>
              <span>Total Payments: {{TotalPayments && TotalPayments.toLocaleString()}}</span><br>
            <span>Total Balance: {{(TotalBalance && TotalBalance.toLocaleString())}}</span>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="subtitle-2 text--primary">
            <!-- start of table -->
            <v-data-table
              :mobile-breakpoint="0"
              :headers="headers"
              :items="orders"
              :search="search"
            >
              <template v-slot:item.DocTotal="{ item }">
                <span>{{ item.DocTotal.toLocaleString() }}</span>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn icon :to="`/goods-receipt/${item.id}`">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    TotalPurchases: null,
    TotalPayments: null,
    TotalBalance: null,
    headers: [
      // { text: "Doc No.", value: "DocNum" },
      { text: "Supplier", value: "ocrd.Name" },
      { text: "Delivery No.", value: "DeliveryNo" },
      { text: "Memo", value: "memo" },
      { text: "Total Order Amount", value: "DocTotal" },
      { text: "Date", value: "DocDate" },
      { text: "View Details", value: "action" },
    ],
    orders: [],
  }),
  methods: {
    getOrders() {
      let data = {};
      data.StartDate = new Date().toISOString().substr(0, 10);
      data.CustomerId = null;
      const url = "/daily-records/12";
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.orders = res.ResponseData.AllSales;
            self.TotalPurchases = res.ResponseData.TotalSalesAmount;
            self.TotalPayments = res.ResponseData.TotalPaidSum;
            self.TotalBalance = res.ResponseData.TotalBalance;
            self.$store.commit("loader", false);
          } else {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getOrders();
  },
};
</script>